<template>
  <div class="roles-page pa-4 mt-15">

    <!-- === ФИЛЬТР === -->
    <v-text-field
      v-model="search"
      label="Фильтр по ФИО"
      density="compact"
      variant="outlined"
      class="mb-4"
    />

    <!-- === ТАБЛИЦА ВСЕХ ПОЛЬЗОВАТЕЛЕЙ === -->
    <v-data-table
      :headers="userHeaders"
      :items="allUsers"
      :search="search"
      item-key="id"
      density="compact"
      class="elevation-1"
      @click:row="selectUser"
    />

    <!-- === РОЛИ ПОЛЬЗОВАТЕЛЯ === -->
    <div v-if="selectedUser" class="mt-6">

      <div class="roles-heading d-flex justify-space-between align-center mb-2">
        <h3 class="text-h6">
          Роли пользователя: {{ selectedUser?.item?.fio }}
        </h3>

        <v-btn
          color="primary"
          prepend-icon="mdi-plus"
          @click="roleDialog = true"
        >
          Добавить роль
        </v-btn>
      </div>

      <v-data-table
        :headers="roleHeaders"
        :items="userRoles"
        item-key="role"
        density="compact"
        class="elevation-2"
        style="border-radius: 8px"
      >
        <template #item.role="{ item }">
          <v-chip color="primary" variant="flat" class="ma-1" label>
            {{ item }}
          </v-chip>
        </template>

        <template #item.actions="{ item }">
          <v-btn
            icon="mdi-delete"
            size="small"
            color="red-darken-1"
            variant="text"
            @click.stop="removeRole(item)"
          />
        </template>
      </v-data-table>
    </div>

    <!-- === МОДАЛКА ДОБАВЛЕНИЯ РОЛИ === -->
    <v-dialog v-model="roleDialog" max-width="500px">
      <v-card>
        <v-card-title class="text-h6">Добавить роль пользователю</v-card-title>

        <v-card-text>
          <v-select
            v-model="selectedRoleToAdd"
            :items="filteredAllRoles"
            item-title="name"
            item-value="name"
            label="Выберите роль"
            variant="outlined"
            density="compact"
          />
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn text @click="closeDialog">Отмена</v-btn>
          <v-btn color="primary" @click="saveRole">Сохранить</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import requestService from '@/services/request.service';

export default {
  data() {
    return {
      search: "",
      allUsers: [],
      userHeaders: [
        { title: "id", key: "id"},
        { title: "ФИО", key: "fio", },
        { title: "email", key: "email"},
        { title: "userName", key: "userName"},
        { title: "Номер телефона", key: "phoneNumber"},
      ],
      selectedUser: null,
      userRoles: [],
      roleHeaders: [
        { title: "Роль", key: "role" },
        { title: "Действия", key: "actions", sortable: false },
      ],
      roleDialog: false,
      selectedRoleToAdd: null,
      allRoles: [],
    };
  },

  methods: {
    getAllUsers() {
      const url = `${process.env.VUE_APP_BASE_URL}/v3/users/all`
      requestService.get(url)
        .then(res => {
          this.allUsers = res.data || []
        })
        .catch(err => console.log(err))
    },

    selectUser(event, user) {
      this.selectedUser = user;
      const url = `${process.env.VUE_APP_BASE_URL}/v3/userRoles/${user.internalItem.key}`
      requestService.get(url)
      .then(data => {
        this.userRoles = data.data.roles
      })
      .catch(err => {
        console.log(err)
      })
    },
    getAllRoles() {
      const url = `${process.env.VUE_APP_BASE_URL}/v3/userRoles/all`
      requestService.get(url)
      .then(data => {
        this.allRoles = data.data.roles
      })
      .catch(err => {
        console.log(err)
      })
    },
    removeRole(roleName) {
      const url = `${process.env.VUE_APP_BASE_URL}/v4/Groups/removeRoleFromUser/${this.selectedUser.internalItem.key}/${roleName}`
      requestService.get(url)
      .then(() => {
        this.selectUser(null, this.selectedUser);
      })
      .catch(err => {
        console.log(err)
      })
    },

    closeDialog() {
      this.roleDialog = false;
      this.selectedRoleToAdd = null;
    },

    saveRole() {
      if (!this.selectedRoleToAdd) return;
      const url = `${process.env.VUE_APP_BASE_URL}/v3/userRoles/edit/${this.selectedUser.internalItem.key}`
      const payload = {
        roles: [this.selectedRoleToAdd, ...this.userRoles]
      }
      requestService.post(url, payload)
      .then(() => {
        this.selectUser(null, this.selectedUser)
        this.closeDialog();
      })
      .catch(err => {
        console.log(err)
      })
    }
  },
  computed: {
    filteredAllRoles() {
      if (!this.userRoles) {
        return this.allRoles
      } else {
        return this.allRoles.filter(el => !this.userRoles.includes(el.name))
      }
    }
  },
  mounted() {
    this.getAllUsers();
    this.getAllRoles();
  }
};
</script>

<style scoped>
@media (max-width: 480px) {
  .roles-page {
    padding: 12px !important;
  }

  .roles-heading {
    flex-direction: column;
    align-items: stretch !important;
    gap: 10px;
  }

  .roles-heading h3 {
    overflow-wrap: anywhere;
  }

  .roles-heading .v-btn {
    width: 100%;
  }
}
</style>
